import React from 'react';
import axios from 'axios';
import stickyError from 'components/stickyError';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import { Checkbox, Form, Row, Col, message, Input } from 'antd';

import apiPath from 'apiPath';

class ShipStatus extends React.Component {

    state = {
        conditionVisibile: true,
        deansChecked: null,
        fullAdmitChecked: null,
        studentChecked: null,
        StudentLifeWatch: false,
        DeansWatch: false,
        FullAdmit: false
    }
    //submit form
    handleSubmit = (event) => {
        event.preventDefault();
        this.props.isSubmitting();
        this.props.form.validateFields((err, values) => {
            this.postShipStatus(values);
        })
        this.props.isSubmitted();
    }
    //Get ship status, set checkbox value to state depending on the result of the api call
    getShipStatus = () => {
        axios.get(apiPath + '/admissions/getShipStatus', { withCredentials: true }).then(result => {
            if (result.data[0] === undefined || result.data[0].StudentLifeWatch === "0") {
                this.setState({ studentChecked: false })
            } else {
                this.setState({ studentChecked: true })
            }
            if (result.data[0] === undefined || result.data[0].DeansWatch === "0") {
                this.setState({ deansChecked: false })
            } else {
                this.setState({ deansChecked: true })
            }
            if (result.data[0] === undefined || result.data[0].FullAdmit === "0") {
                this.setState({ fullAdmitChecked: false })
            } else {
                this.setState({ fullAdmitChecked: true })
            }
            this.props.form.setFieldsValue({
                StudentLifeWatch: (result.data[0] === undefined) ? '' : result.data[0].StudentLifeWatch,
                SLW_Note: (result.data[0] === undefined) ? '' : result.data[0].SLW_Note,
                DeansWatch: (result.data[0] === undefined) ? '' : result.data[0].DeansWatch,
                DW_Note: (result.data[0] === undefined) ? '' : result.data[0].DW_Note,
                FullAdmit: (result.data[0] === undefined) ? '' : result.data[0].FullAdmit,
                FA_Note: (result.data[0] === undefined) ? '' : result.data[0].FA_Note
            })
        })
    }

    //post ship status and check to see if(chexbox is checked then is note also filled out?)
    postShipStatus = (values) => {
        this.validateShipNote();
    }

    validateShipNote = (values) => {
        this.props.form.validateFields((errors, values) => {
            if (
                ((values.SLW_Note === null || values.SLW_Note.length > 0) && (values.StudentLifeWatch === "0" || values.StudentLifeWatch === false)) &&
                ((values.DW_Note === null || values.DW_Note.length > 0) && (values.DeansWatch === "0" || values.DeansWatch === false))
            ) {
                return stickyError('You must check the corresponding box.');
            } else if (errors) {
                return stickyError('You must enter a note.');
            } else {
                axios.put(apiPath + '/admissions/postShipStatus', {
                    StudentLifeWatch: values.StudentLifeWatch,
                    SLW_Note: values.SLW_Note,
                    DeansWatch: values.DeansWatch,
                    DW_Note: values.DW_Note,
                    FullAdmit: values.FullAdmit,
                    FA_Note: values.FA_Note
                },
                    { withCredentials: true }).then(result => {
                    })
                message.success('Saved!');
            }
        })
    }
    //checkbox on change setting to state
    deansChecked = (event) => {
        this.setState({ deansChecked: event.target.checked });
    }

    studentChecked = (event) => {
        this.setState({ studentChecked: event.target.checked });
    }

    fullAdmitChecked = (event) => {
        this.setState({ fullAdmitChecked: event.target.checked });
    }

    componentDidMount() {
        this.getShipStatus();
    }

    render() {
        const { TextArea } = Input;
        const { getFieldDecorator } = this.props.form;

        return (

            <Form onSubmit={this.handleSubmit}>
                <span style={{ visibility: this.state.conditionVisibile ? 'visible' : 'hidden' }}>
                    <p>Select a ship status for the student</p>
                    <br />
                    <Row type="flex" justify="start">
                        <Col>
                            <Form.Item>
                                {getFieldDecorator('StudentLifeWatch', {
                                    initialValue: ""
                                })(
                                    <Checkbox checked={this.state.studentChecked} onChange={this.studentChecked}>Student Life Watch</Checkbox>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item>
                                {getFieldDecorator('SLW_Note', {
                                    initialValue: "",
                                    rules: [{
                                        required: this.state.studentChecked === true, message: 'You must submit a note'
                                    }]
                                })(
                                    <TextArea />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row type="flex" justify="start">
                        <Col>
                            <Form.Item>
                                {getFieldDecorator('DeansWatch', {
                                    initialValue: ""
                                })(
                                    <Checkbox checked={this.state.deansChecked} onChange={this.deansChecked}>Deans Watch</Checkbox>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item>
                                {getFieldDecorator('DW_Note', {
                                    initialValue: "",
                                    rules: [{
                                        required: this.state.deansChecked === true, message: 'You must submit a note'
                                    }]
                                })(
                                    <TextArea />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <br />
                    <br />
                    <div style={{visibility: 'hidden'}}>
                    <Row type="flex" justify="start">
                        <Col>
                            <Form.Item>
                                {getFieldDecorator('FullAdmit', {
                                    initialValue: this.state.fullAdmitChecked
                                })(
                                    <Checkbox disabled={this.state.deansChecked || this.state.studentChecked} checked={this.state.fullAdmitChecked} onChange={this.fullAdmitChecked}>Full Admit</Checkbox>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item>
                                {getFieldDecorator('FA_Note', {
                                    initialValue: "",
                                })(
                                    <TextArea disabled={this.state.deansChecked || this.state.studentChecked} />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    </div>
                    <Form.Item>
                        <SaveButton
                            disabled={!this.props.form.isFieldsTouched()}
                            loading={this.props.getStatus().submitting} />
                    </Form.Item>
                </span>
            </Form>
        );
    }
}

export default withSpin(Form.create()(ShipStatus));


// WEBPACK FOOTER //
// ./portal-components/Portal/Admissions/ShipStatus.jsx